import React from 'react';
import './WhyChoose.css';

const WhyChoose = () => {
  const benefits = [
    { title: '95% Voice Accuracy', description: 'Industry-leading precision in speech recognition' },
    { title: 'Instant Analysis', description: 'Get detailed insights in seconds, not hours' },
    { title: 'All Trading Types', description: 'Stocks, forex, crypto, options, and more' },
    { title: 'Smart Organization', description: 'Build and manage your trading history intelligently' },
    { title: '4.8/5 Star Rating', description: 'Trusted by thousands of traders' }
  ];

  return (
    <section className="why-choose section-padding">
      <div className="container">
        <h2 className="section-title">Built for Traders</h2>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit">
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
